<template>
  <div
    :style="{
      margin: isWideScreen ? '10%' : '0%',
      'margin-top': isWideScreen ? '25px' : '0px',
    }"
  >
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="title" v-if="txtList.length > 0">
          {{ txtList[0] }}
        </span>
        <!-- <el-button style="float: right; padding: 3px 0" type="text"
          >操作按钮</el-button
        > -->
      </div>
      <div>
        <span v-for="(txt, index) in txtList" :key="index">
          <h3 v-if="index > 0 && issubTitle(txt)" class="subtitle">
            {{ txt }}
          </h3>
          <p v-else-if="index > 0 && isValidsubTitle(txt)">{{ txt }}</p>
        </span>
      </div>
    </el-card>
  </div>
</template>

<script>
import { Card } from "element-ui";

const base64 = require("base-64");
export default {
  name: "userprotocol",
  components: {
    ElCard : Card
  },
  props: {
    isWideScreen: Boolean,
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {
    txt() {
      return require("../components/" + this.$t("userprotocol"));
    },
    txtList() {
      const base64String = this.txt.split("base64,")[1];
      const buffer = Buffer.from(base64String, "base64");
      const decodedString = buffer.toString("utf-8");

      return decodedString.split("\n");
    },
  },
  methods: {
    issubTitle(txt) {
      return (
        (txt.length > 0 && txt.indexOf("、") > 0 && txt.indexOf("、") < 3) ||
        (txt.indexOf(".") > 0 && txt.indexOf(".") < 3)
      );
    },
    isValidsubTitle(txt) {
      return txt.length > 0;
    },
  },
};
</script>

<style>
/* 自定义小标题的样式 */
.subtitle {
  font-size: 1.3rem; /* 设置小标题的字号 */
  font-weight: bold; /* 可选的，设置字体为粗体 */
  margin-bottom: 16px; /* 可选的，设置小标题下方的间距 */
}
.box-card {
  text-align: left;
}
.box-card .title {
  font-size: 1.5rem; /* 设置小标题的字号 */
  font-weight: bold; /* 可选的，设置字体为粗体 */
}
</style>


// WEBPACK FOOTER //
// src/views/userprotocol.vue